<template>
  <div class="homeWrap">
    <!-- <noticeWX></noticeWX> -->
    <!-- <div class="mainCom w1200 clearfix" :style="{backgroundImage: 'url('+bannerBg+')'}"> -->
    <div class="mainCom clearfix">
      <div class="mainComL fl">
        <menuWX></menuWX>
      </div>
      <div class="mainComR fr">
        <!-- <div class="downBtn" style="position: relative;">
          <img :src="downBtn" alt="" @click="goDownLoad" />
        </div> -->
        <!-- 视频和轮播图 -->
        <div class="box1 clearfix mb20">
          <div class="banner medio banner1 fl" :style="{ backgroundImage: `url(${banner1})` }">
            <img class="video" src="@/assets/imgs/home/videoBg.png" alt="">
            <!-- <video class="video" :poster="require('@/assets/imgs/home/videoCover.png')" controls>
              <source src="https://download-wx.qtthtech.com/images/webvideo/wxol.mp4" type="video/mp4" />
              Sorry, your browser doesn't support embedded videos.
            </video> -->
          </div>
          <div class="banner blingBox banner1 fr" :style="{ backgroundImage: `url(${banner1})` }">
            <el-carousel height="210px" class="arousel">
              <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <a v-if="item.links" :href="item.links" target="_blank"><img :src="item.imgUrl" /></a>
                <img v-else :src="item.imgUrl" @click="goDownLoad(item.links)" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!-- 活动入口 -->
        <div class="box2 mb20">
          <div class="banner" @click="goActivity(item)" v-for="(item, index) in activityImgs" :key="index">
            <img class="pic" :src="item.imgUrl" alt="" />
          </div>
          <!-- <div class="banner" @click="goActivity"> <img class="pic" :src="banner3" alt="" /> </div>
          <div class="banner" @click="goShangcheng"><img class="pic" :src="banner4" alt=""></div>
          <div class="banner" @click="goSongChart"><img class="pic" :src="banner5" alt=""></div> -->

          <div class="banner">
            <div class="bannerSix clearfix">
              <div class="picSmall fl" @click="goIntegralShop">
                <img :src="banner6" alt="" />
              </div>
              <div class="picSmall fl" @click="goCeremony">
                <img :src="banner7" alt="" />
              </div>
              <div class="picSmall fl" @click="goDaily">
                <img :src="banner8" alt="" />
              </div>
              <div class="picSmall fl" @click="goRecruit">
                <img :src="banner9" alt="" />
              </div>
            </div>
          </div>
        </div>
        <!-- 新闻 -->
        <div class="box3 mb20">
          <div class="homenews" :style="{ backgroundImage: 'url(' + newsBg + ')' }">
            <span class="more" @click="goNews">更多 &gt;</span>
            <div class="tit">
              <span v-for="(item, index) in newsTitle" :class="{ active: newsActive == index }"
                @click="tagChange(item, index)">{{ item.title }}</span>
            </div>
            <div class="consWrap">
              <div class="itemGroup">
                <div class="item" v-for="(item, index) in newsCons" @click="goNewsDetail(item)">
                  <span>{{ item.title }}</span>
                  <span class="fr" v-if="index != 0">{{ item.pubDate }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="newsRWrap txtC">
            <img border="0" style="margin-top: 5px;" :src="newsIcon1" @click="alertEmail" />
            <a target=" _blank" href="tencent://message/?uin=202496859&Site=wx.qtthtech.com&Menu=yes">
              <img style="margin: 10px 0;" :src="newsIcon2" alt="点击这里给我发消息" title="点击这里给我发消息" />
            </a>
            <img :src="newsIcon3" alt="" />
            <!-- <a target="_blank" href="tencent://message/?uin=3003533756&Site=wx.qtthtech.com&Menu=yes">
              <img border="0" :src="newsIcon1" alt="点击这里给我发消息" title="点击这里给我发消息" />
            </a>
            <img :src="newsIcon2" alt="" @click="alertEmail" /> -->
          </div>
        </div>
        <!-- 游戏特色  名人堂 -->
        <div class="box4">
          <!-- 游戏资料 -->
          <div class="GameData">
            <div class="GameDataitem" v-for="(item, index) in GameDataitem" :key="index">
              <p class="Tit">{{ item.tit }}</p>
              <p class="Con">{{ item.con }}</p>
              <div class="item">
                <span v-for="(item1, index) in item.list" @click="goGameData(item.type, item1)">{{ item1 }}</span>
              </div>
            </div>
          </div>
          <!-- 名人堂 -->
          <div class="hallOfFameWrap">
            <div class="hallOfFame">
              <homeTitWX :title="'名人堂'" :type="'HallOfFame'" :isMore="true"></homeTitWX>
              <div class="user_skills">
                <div class="item">
                  <p>期数</p>
                  <p>充值名人</p>
                  <p>天梯名人</p>
                  <p>赛季名人</p>
                </div>
                <div class="item" v-for="item in hallOfFameData" :key="item.periodName">
                  <p>{{ item.periodName }}</p>
                  <p>{{ item.usernickInfo[0] }}</p>
                  <p>{{ item.usernickInfo[1] }}</p>
                  <p>{{ item.usernickInfo[2] }}</p>
                </div>
              </div>

            </div>

          </div>
        </div>
        <!-- 排名 -->
        <div class="box5 mb20" :style="{ backgroundImage: 'url(' + rankBg + ')' }">
          <div class="rankWrap">
            <ranking></ranking>
          </div>
        </div>



        <div class="box6 bgWhite">
          <div class="specialWrap">
            <div class="mb5">
              <homeTitWX :title="'精彩瞬间'" :isMore="false"></homeTitWX>
            </div>
            <div class="mb10">
              <!-- <homeTit2WX :title="['游戏截图', '玩家风采', '官方图片']" :type="'special'" @chageTag="chageTag"></homeTit2WX> -->
              <homeTit2WX :title="['游戏截图', '官方图片']" :type="'special'" @chageTag="chageTag"></homeTit2WX>
            </div>
            <div class="consWrap">
              <div style="  position: relative;  z-index: 0; width: 930px; height: 200px; ">
                <div style=" position: absolute; z-index: 0;  width: 932px; height: 200px; background: #fff;
                  " :style="{ zIndex: zIndex1 }">
                  <div class="swiper-container swiper-container0" style="height: 100%;">
                    <div class="swiper-wrapper">
                      <!-- 这里的数据需要使用自己定义的数组或者从后端返回的数组 -->
                      <div class="swiper-slide swiper-no-swiping" v-for="item in game0" :key="item">
                        <img style="width: 97%;height: 100%;" :src="item" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div style="
                    position: absolute;
                    z-index: 0;
                    width: 932px;
                    height: 200px;
                    background: #fff;
                  " :style="{ zIndex: zIndex2 }">
                  <div class="swiper-container swiper-container1">
                    <div class="swiper-wrapper swiper-wrapper1">
                      这里的数据需要使用自己定义的数组或者从后端返回的数组
                      <div class="swiper-slide swiper-no-swiping swiper-slide1" v-for="item in game1" :key="item.id">
                        <img :src="item" alt="" />
                      </div>
                    </div>
                  </div>
                </div> -->
                <div style=" position: absolute;  z-index: 0; width: 932px; height: 200px; background: #fff;"
                  :style="{ zIndex: zIndex3 }">
                  <div class="swiper-container swiper-container2">
                    <div class="swiper-wrapper swiper-wrapper2">
                      <!-- 这里的数据需要使用自己定义的数组或者从后端返回的数组 -->
                      <div class="swiper-slide swiper-no-swiping swiper-slide2" style="max-width:200px;"
                        v-for="item in game2" :key="item.id">
                        <img style="width: 97%;height: 100%;" :src="item" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 活动 -->
        <!-- <div style="position: absolute;height: 300px;top: 88%; left: 36%;">
          <img src="@/assets/imgs/home/bannerBg.png" alt="">
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getNewslistApi } from '@/api/news/index.js' //新闻Api
import { getIndexFamousRankApi } from '@/api/hallOfFame/index.js' //名人堂
import { getBannerListApi } from '@/api/public.js'

import ranking from './ranking';
// import noticeWX from "./notice";
import homeTitWX from "./homeTit";
import homeTit2WX from "./homeTit2";
import menuWX from "@/components/Menu";
import { publicUrl } from "@/common/publicUrl.js";
import Cookies from "js-cookie";
import Swiper from "swiper"; // 导入Swiper库

import axios from "axios";
export default {
  name: "home",
  components: {
    // noticeWX,
    homeTitWX,
    homeTit2WX,
    menuWX,
    ranking
  },
  data() {
    return {
      bannerBg: require("@/assets/imgs/home/bannerBg.png"),
      downBtn: require("@/assets/imgs/home/downBtn.png"),
      banner1: require("@/assets/imgs/home/banner1.png"),
      banner2: require("@/assets/imgs/home/banner2.png"),
      banner3: require("@/assets/imgs/home/banner3.png"),
      banner4: require("@/assets/imgs/home/banner4.png"),
      banner5: require("@/assets/imgs/home/banner5.png"),
      banner6: require("@/assets/imgs/home/banner6.png"),
      banner7: require("@/assets/imgs/home/banner7.png"),
      banner8: require("@/assets/imgs/home/banner8.png"),
      banner9: require("@/assets/imgs/home/banner9.png"),
      bannerList: [], // 轮播
      activityImgs: [], // 活动图片
      newsActive: 0,
      newsTitle: [
        { catId: 0, title: "全部" },
        { catId: 1, title: "新闻" },
        { catId: 2, title: "活动" },
        { catId: 3, title: "公告" },
      ],
      newsCons: [], // 新闻列表数据
      newsBg: require("@/assets/imgs/home/newsBg.png"),
      newsIcon1: require("@/assets/imgs/home/newsIcon1.png"),
      newsIcon2: require("@/assets/imgs/home/newsIcon2.png"),
      newsIcon3: require("@/assets/imgs/home/newsIcon3.png"),

      hallOfFameData: [],

      rankBg: require("@/assets/imgs/home/rankBg.png"),
      rankData: [],
      zIndex1: 3,
      zIndex2: 2,
      zIndex3: 1,
      game0: [
        require("@/assets/imgs/home/game0/0.png"),
        require("@/assets/imgs/home/game0/1.png"),
        require("@/assets/imgs/home/game0/2.png"),
        require("@/assets/imgs/home/game0/3.png"),
        require("@/assets/imgs/home/game0/4.png"),
        require("@/assets/imgs/home/game0/5.png"),
      ],
      game1: [
        require("@/assets/imgs/home/game1/0.png"),
        require("@/assets/imgs/home/game1/1.png"),
        require("@/assets/imgs/home/game1/2.png"),
        require("@/assets/imgs/home/game1/3.png"),
        require("@/assets/imgs/home/game1/4.png"),
        require("@/assets/imgs/home/game1/5.png"),
        require("@/assets/imgs/home/game1/6.png"),
        require("@/assets/imgs/home/game1/7.png"),
        require("@/assets/imgs/home/game1/8.png"),
        require("@/assets/imgs/home/game1/9.png"),
        require("@/assets/imgs/home/game1/10.png"),
        require("@/assets/imgs/home/game1/11.png"),
        require("@/assets/imgs/home/game1/12.png"),
        require("@/assets/imgs/home/game1/13.png"),
        require("@/assets/imgs/home/game1/14.png"),
        require("@/assets/imgs/home/game1/15.png"),
        require("@/assets/imgs/home/game1/16.png"),
        require("@/assets/imgs/home/game1/17.png"),
        require("@/assets/imgs/home/game1/18.png"),
        require("@/assets/imgs/home/game1/19.png"),
        require("@/assets/imgs/home/game1/20.png"),
      ],
      game2: [
        require("@/assets/imgs/home/game2/0.png"),
        require("@/assets/imgs/home/game2/1.png"),
        require("@/assets/imgs/home/game2/2.png"),
        require("@/assets/imgs/home/game2/3.png"),
      ],

      // 游戏资料
      GameDataitem: [
        {
          tit: '游戏资料',
          con: '游戏指引',
          type: 0,
          list: ['新手指引', '故事背景', '成就系统', '增值系统', '交易系统', '副本系统', 'PK系统', '竞技系统']
        },
        {
          tit: '',
          con: '游戏特色',
          type: 1,
          list: ['战斗系统', '宠物捕捉', '宠物成长', '技能卡片', '装备讲解', '镶嵌系统', '词缀系统', '庄园系统']
        },

      ],
    };
  },
  created() {
    this.special2Icon = this.game0;
    this.getNewsData(); //新闻
    this.getHallOfFameData(); // 获取名人堂数据
    this.getBannerList(); //活动入口
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    this.$nextTick(() => {
      this.initSwiper();
      this.initSwiper1();
      this.initSwiper2();
    });
  },
  methods: {
    /* banner轮播 */
    async getBannerList() {
      await getBannerListApi({})
        .then((res) => {
          if (res.data.state == 200) {
            this.bannerList = res.data.data.list;
            this.activityImgs = res.data.data.activityImgs.reverse();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    /* 精彩瞬间 */
    chageTag(data) {
      if (data.type == "special") {
        if (data.ind == 0) {
          this.zIndex1 = 4;
          this.zIndex2 = 2;
          this.zIndex3 = 3;
        } else if (data.ind == 1) {
          this.zIndex1 = 1;
          this.zIndex2 = 4;
          this.zIndex3 = 3;
        } else if (data.ind == 2) {
          this.zIndex1 = 1;
          this.zIndex2 = 2;
          this.zIndex3 = 4;
        }
      } else if (data.type == "rank") {

      }
    },
    initSwiper() {
      new Swiper(".swiper-container0", {
        autoplay: {
          delay: 3000, //1秒切换一次
        }, //等同于以下设置

        loop: true,
        slidesPerView: 4, //显示4个
        speed: 1000,
        initialSlide: 0,
      });
    },
    initSwiper1() {
      new Swiper(".swiper-container1", {
        autoplay: {
          delay: 3000, //1秒切换一次
        }, //等同于以下设置
        delay: 8000, //1秒切换一次
        loop: true,
        slidesPerView: 4, //显示4个
        speed: 1000,
        initialSlide: 0,
      });
    },
    initSwiper2() {
      new Swiper(".swiper-container2", {
        autoplay: {
          delay: 3000, //1秒切换一次
        }, //等同于以下设置
        delay: 8000, //1秒切换一次
        loop: true,
        slidesPerView: 4, //显示4个
        speed: 1000,
        initialSlide: 0,
      });
    },

    /* 新闻相关 */
    tagChange(item, index) {
      // 点击新闻tag
      this.newsActive = index;
      this.getNewsData();
    },
    async getNewsData() {
      // 获取初始数据
      let data = {
        catId: this.newsTitle[this.newsActive].catId,
        types: "home",
      };
      // axios
      //   .post("/news/getNewslist", data)
      await getNewslistApi({
        ...data
      })
        .then((res) => {
          if (res.data.state == 200) {
            if (res.data.data.list) {
              if (res.data.data.list.length >= 5) {
                this.newsCons = res.data.data.list.slice(0, 4);
              } else {
                this.newsCons = res.data.data.list;
              }
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    goGameData(type, item) {
      this.$router.push(`/gameDetail?type=${type}&item=${item}`);
    },

    /* 名人堂相关*/
    async getHallOfFameData() {
      await getIndexFamousRankApi({})
        .then((res) => {
          if (res.data.state == 200) {
            if (res.data.data.famousResponses) {
              this.hallOfFameData = res.data.data.famousResponses.splice(0, 7);
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },



    /*************************** 跳转相关 */
    goNewsDetail(item) {
      // 跳转到新闻详情
      this.$router.push({
        path: "/newsDetail",
        query: {
          newsId: item.newsId,
        },
      });
    },
    goNews() {
      // 跳转到新闻页面
      this.$router.push("/news");
    },
    goRecruit() {
      // 跳转到招募页面
      this.$router.push("/recruit");
    },
    goDaily() {
      // 跳转到日常页面
      this.$router.push("/daily");
    },
    goCeremony() {
      // 跳转到礼遇页面
      this.$router.push("/ceremony");
    },
    goIntegralShop() {
      // window.open(publicUrl.shopIntegralUrl, '_blank');    // 商城// 跳转到积分商城
      this.$router.push("/exchange"); // 跳转到兑换中心页面
    },
    goSongChart() {
      // 跳转到歌曲打榜
      this.$message.error('暂时还没有数据哦！')
      return false
      // this.$router.push('/chidrenDay')  // 跳转到欢乐六一页面
      // this.$router.push('/duanwu')  // 跳转到端午活动页面
      // this.$router.push("/dancing"); // 跳转到自由舞会页面
      // this.$router.push('/qixi')  // 跳转到七夕
      // this.$router.push('/throwinggame')  // 跳转到骰子
    },
    goShangcheng() {
      // 商城
      this.$message.error('暂时还没有数据哦！')
      // this.$router.push({
      //   path: "/account",
      //   query: {
      //     type: 2,
      //   },
      // });
      // this.$router.push('/sixoneeight')  // 跳转到618活动页面
      // this.$router.push('/throwinggame')  // 跳转到骰子
    },
    goActivity(item) {
      // this.$router.push('/SignIn')
      // console.log(item.links.indexOf("/#/") !== -1, '666',);

      // 跳转活动图片
      if (item.links == '/') {
        this.$message.error('暂时还没有数据哦！')
      }else if (item.links.indexOf("/#/") !== -1) {
        window.open(item.links)
      } else if (item.links.indexOf("?") == -1) {
        this.$router.push(item.links);
      }  else {
        this.$router.push({
          path: "/account",
          query: {
            type: 2,
          },
        });
      }

      // this.$router.push('/notice')
    },
    goBlindBox() {
      // 跳转商城盲盒页面
      window.open(publicUrl.shopBlindBoxUrl, "_blank"); // 商城
    },
    goDownLoad() {
      // 跳转到下载中心
      this.$router.push("/downLoad");
    },
    alertEmail() {
      this.$message.warning("MPO_service@qtthtech.com");
      // this.$message.warning("敬请期待！！！");

    },
    // godemo(){
    //   window.open("https://openapi.alipay.com/gateway.do?alipay_sdk=alipay-sdk-PHP-4.11.14.ALL&app_id=2021004123604482&biz_content=%7B%22out_trade_no%22%3A%22wx9i17320240605175101447708%22%2C%22total_amount%22%3A0.01%2C%22subject%22%3A%22%E6%B8%B8%E6%88%8F%E5%85%85%E5%80%BC%22%2C%22timeout_express%22%3A%2290m%22%2C%22product_code%22%3A%22FAST_INSTANT_TRADE_PAY%22%7D&charset=utf-8&format=json&method=alipay.trade.page.pay&notify_url=http%3A%2F%2Fceshi.9i173.com%2FNotify%2Falipay&sign=NojwEEBeEi3Hx9prQQGny8tbGNVl87hlMn0FG%2FABeFW1Ukd%2FmhWXXtGvCdYnXRxBO%2BM6D%2FbUA9qE%2BkljI1Fy4AnP6Ei6srC5obwkWUlQFPoAftPcdX0RT6NuQ01nf62qRKQYb2%2BgqEi%2Bqea5ijAmP0Tzf2xoHbj2mPQpjRLAh6v9EalAKbRZ59%2FvnOO067l94ziTRlpnc5lb4orI95N%2B0glGmgCK%2BDHa77qqFy%2F%2FvxqaTDYXUudI5IINqoYEvbAy7x1nlly8Yll3Nmaa2GK%2FNSVi4HkjYLAYBLjga2u%2BtlCnzisJmvVg54JfihU7g9vPcrrqHY6y8tWmZ5t3TS1hjg%3D%3D&sign_type=RSA2&timestamp=2024-06-05+17%3A51%3A23&version=1.0")
    // }
  },
};
</script>
<style lang="less" scoped>
.homeWrap {
  padding-bottom: 40px;

  .mainCom {
    width: 1250px;
    margin: 0 auto;
    padding-top: 680px;
    background-repeat: no-repeat;
    background-position: center 337px;

    .mainComL {
      // padding-top: 124px;
      width: 280px;
    }

    .mainComR {
      .noData {
        text-align: center;
      }

      .downBtn {
        text-align: right;
        cursor: pointer;
      }

      .box1 {
        .banner {
          width: 470px;
          height: 270px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .medio {}

        .banner1 {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-size: 100% 100%;

          .video {
            width: 94%;
            height: 190px;
          }

          .arousel {
            width: 94%;
            height: 210px;
          }
        }

        .blingBox {
          cursor: pointer;

        }
      }

      .box2 {
        display: flex;
        margin-right: -20px;

        .banner {
          margin-right: 12px;
          width: 228px;
          height: 228px;
          overflow: hidden;

          .pic {
            width: 100%;

            &:hover {
              cursor: pointer;
            }
          }

          .bannerSix {
            margin-right: -20px;

            .picSmall {
              margin-right: 10px;
              width: 112px;
              height: 120px;
              overflow: hidden;

              img {
                width: 100%;

                &:hover {
                  cursor: pointer;
                }
              }
            }
          }

          &:last-child {
            margin-top: -12px;
            height: 240px;
          }
        }
      }

      .box3 {
        display: flex;

        .homenews {
          background-size: 100% 100%;
          position: relative;
          z-index: 1;
          margin-right: 10px;
          min-width: 790px;
          width: 790px;
          background-repeat: no-repeat;

          .more {
            position: absolute;
            right: 70px;
            top: 27px;
            z-index: 1;
            line-height: 40px;
            cursor: pointer;
          }

          .tit {
            height: 40px;
            line-height: 44px;
            padding-top: 25px;
            width: 86%;
            margin: auto;

            span {
              margin: 0 100px 0 20px;
              font-size: 16px;
              cursor: pointer;
            }

            .active {
              padding: 2px;
              font-weight: 700;
              border-bottom: 2px solid #333333;
            }
          }

          .consWrap {
            padding: 15px 20px;
            width: 86%;
            margin: auto;

            .itemGroup {
              padding: 0px 20px;
              height: 175px;
              box-sizing: border-box;
              border-radius: 6px 6px 6px 6px;

              .item {
                padding: 12px 0;
                border-bottom: 1px dashed #999999;
                cursor: pointer;

                span {
                  font-size: 16px;
                }

                &:first-child {
                  span {
                    font-size: 18px;
                    color: #000000;
                  }
                }

                &:last-child {
                  border-bottom: none;
                }

                &:hover {
                  color: #000000;
                }
              }
            }
          }
        }

        .newsRWrap {
          // padding: 188px 0 10px;
          background-repeat: no-repeat;
          width: 150px;

          img {
            cursor: pointer;
            width: 100%;
          }
        }
      }

      .box4 {

        height: 350px;
        position: relative;
        display: flex;

        .GameData {
          width: 52%;
          background-image: url(../../assets/imgs/home/gameData.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          display: flex;
          justify-content: space-between;
          padding: 45px 35px;

          // .border-bottom: 1px dashed #999999;
          .GameDataitem {
            width: 45%;
            height: 100%;

            p {
              height: 30px;
              line-height: 30px;
              border-bottom: 1px dashed #999999;
              padding-left: 20px;
            }

            .Tit {
              margin-top: 20px;
              font-weight: 600;
              font-size: 20px;
              color: #6C3F00;
            }

            .Con {
              color: #333333;
              font-weight: 800;
              font-size: 16px;
            }

            .item {
              display: flex;
              flex-wrap: wrap;
              padding-left: 20px;
              padding-top: 10px;

              span {
                width: 40%;
                line-height: 15px;
                font-size: 16px;
                margin: 7px 0;
                cursor: pointer;
                color: #686868;
              }

              span:hover {
                color: #6C3F00;
                font-size: 18px;
              }

              span:nth-child(2n) {
                text-align: right;
                border-left: #000000 solid 1px;
              }
            }
          }
        }

        .hallOfFameWrap {
          background-image: url(../../assets/imgs/home/hallOfFameWrap.png);
          background-size: 100% 96%;
          background-repeat: no-repeat;
          margin-right: 10px;
          width: 43%;

          .hallOfFame {
            width: 89%;
            height: 70%;
            position: relative;
            top: 50%;
            left: 51%;
            transform: translate(-50%, -50%);

            .user_skills {
              color: #6C3F00;
              width: 100%;
              height: 200px;
              margin: auto;
              border: 1px solid #000000;
              border-bottom: none;
              margin-top: 10px;

              .item {
                display: flex;
                border-bottom: 1px solid #000000;
                border-right: none;

                p {
                  border-right: 1px solid #000000;
                  padding: 2px;
                  width: 29%;
                  height: 20px;
                  line-height: 20px;
                  text-align: center;
                }

                p:nth-child(1) {
                  width: 13%;
                }

                p:nth-child(4) {
                  border-right: none;
                }
              }
            }

          }
        }
      }

      .box5 {
        height: 523px;
        background-repeat: no-repeat;

        .rankWrap {
          position: relative;
          height: 100%;
        }
      }

      .box6 {
        .specialWrap {
          padding: 10px;

          .consWrap {
            .cons {
              display: flex;
              justify-content: space-around;
            }
          }

          .mb10 {}
        }
      }
    }
  }
}
</style>
